<template>
  <div>
    <div class="py-10 chapter-color" id="kapitel1">
      <v-container>
        <v-row class="justify-center">
          <v-col cols="12" class="text-center">
            <div
              class="text-uppercase display-2 pa-6 hidden-sm-and-down"
              style="color: #2E3440;"
            >
              Herausforderungen &amp; Chancen
            </div>
            <div
              class="text-uppercase headline pa-6 hidden-md-and-up"
              style="color: #2E3440;"
            >
              Herausforderungen &amp; Chancen
            </div>

            <v-divider
              style="border-color: #0391af; border-width: 5px; width:50%; display: inline-block; border-style: dotted none none none"
            ></v-divider>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="component-color">
      <herausforderungen></herausforderungen>
      <wissen></wissen>
      <beratungsbedarf></beratungsbedarf>
      <zukunftstechnologien></zukunftstechnologien>
      <useFutureTech></useFutureTech>
      <cloudUse3></cloudUse3>
    </div>
  </div>
</template>

<script>
import Herausforderungen from "@/components/topics/chancenherausforderungen/Herausforderungen.vue";
import Wissen from "@/components/topics/chancenherausforderungen/Wissen.vue";
import Beratungsbedarf from "@/components/topics/chancenherausforderungen/Beratungsbedarf.vue";
import Zukunftstechnologien from "@/components/topics/chancenherausforderungen/zukunftstechnologien.vue";
import UseFutureTech from "@/components//topics/chancenherausforderungen/UseFutureTech.vue";
import CloudUse3 from "@/components/topics/chancenherausforderungen/CloudUse3.vue";

export default {
  name: "ChancenHerausforderungen",
  components: {
    Herausforderungen,
    Wissen,
    Beratungsbedarf,
    Zukunftstechnologien,
    UseFutureTech,
    CloudUse3
  }
};
</script>

<style scoped>
.chapter-color {
  background-color: #fff;
}
.component-color {
  background-color: #fff;
}
</style>
